module.exports = ".table .width-10 {\n  width: 10%;\n  max-width: 10%; }\n\n.table .width-20 {\n  width: 20%;\n  max-width: 20%; }\n\n.table .width-30 {\n  width: 30%;\n  max-width: 30%; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.scss
// module id = ./web/modern/components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table.scss
// module chunks = 0